import $ from 'jquery'
import queryString from 'query-string'
import throttle from 'lodash/throttle'

export function initialise() {
  $('[data-html-embed]').each((i, elem) => {
    const $elem = $(elem)
    const $iframe = $elem.find('iframe').first()
    if (!$iframe.length) return

    let width = $iframe.attr('width')
    let height = $iframe.attr('height')
    if (width && height) {
      if (width.indexOf('%') >= 0) {
        const percent = parseFloat(width.substring(0, width.length - 1)) / 100
        width = $elem.parent().width() * percent
      }
      let ratio = 1
      if (height.indexOf('%') >= 0) {
        ratio = 0.5625
      } else {
        ratio = height / width
      }
      $elem.css('padding-top', ratio * 100 + '%')
    } else {
      $elem.addClass('media-16-9')
    }
    $elem.addClass('media')
    $iframe.attr('width', '100%').attr('height', '100%')
  })

  $(window).off('resize', handleResize)
  $(window).on('resize', handleResize)
  handleResize()
}

let isMobile = false

function _handleResize() {
  const newIsMobile = !!window.matchMedia('(max-width: 639px)').matches
  $('[data-html-embed]').each((i, elem) => {
    const $elem = $(elem)
    const $iframe = $elem.find('iframe').first()
    const src = $iframe.attr('src')
    if (src && src.indexOf('embed.windy.com') >= 0) {
      const parts = src.split('?')
      const baseUrl = parts[0]
      const paramString = parts[1]
      const params = queryString.parse(paramString)
      if (!$iframe.attr('data-orig-zoom')) $iframe.attr('data-orig-zoom', params.zoom)
      if (newIsMobile != isMobile) {
        if (newIsMobile) params.zoom = $iframe.data('orig-zoom') - 2
        else params.zoom = $iframe.data('orig-zoom')
        $iframe.attr('src', baseUrl + '?' + queryString.stringify(params))
      }
    }
  })
  isMobile = newIsMobile
}

const handleResize = throttle(_handleResize, 1000 / 10)
